module.exports = __webpack_public_path__ + "static/media/helsinki-port.b88a6eeb.jpg";